// extracted by mini-css-extract-plugin
export default {"container":"footer_container__6ku6I","mode__box":"footer_mode__box__1TRrg","policies":"footer_policies__a2eNm","link":"footer_link__qLzSO","icon__box":"footer_icon__box__ltV2B"};